import React from 'react';
import config from '../../config';

export default function ContactU() {
  return (
    <section id="contact"  className="contact-section bg-black pb-5 signup-section">
      <div className="container">
        <h2 className="text-white text-center">Contact Us</h2>
        <div className="row">
          <div className="col-md-6 mb-3 mb-md-0">
            <div className="card py-4 h-100">
              <div className="card-body text-center">
                <h3>
                  <i title="Map Marked Icon"  className="fas fa-map-marked-alt text-black mb-2 "></i>
                </h3>
                <h4 className="m-0">Address</h4>
                <hr className="my-4" />
                <div className="small text-black-80">{config.address}</div>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-3 mb-md-0">
            <div className="card py-4 h-100">
              <div className="card-body text-center">
                <h3>
           
            <i title="Envelope Icon" className="fas fa-envelope text-black mb-2"></i>
            
                </h3>
                <h4 className="m-0">Email</h4>
                <hr className="my-4" />
                <div className="small text-black-80">
                  <a className="static-link-dark" href={`mailto:${config.email}`}>{config.email}</a>
                </div>
              </div>
            </div>
          </div>
 
        </div>
 
      </div>
    </section>
  );
}
